<template>
  <div class="person-card"
       :class="{ 'person-card--thin-padding': thinPadding }">
    <a :href="url"
       class="person-card__container">
      <div v-if="renderSrc"
           class="person-card__image-wrapper">
        <picture v-if="image">
          <source :srcset="renderSrc">
          <img class="person-card__image"
               :width="image.width"
               :height="image.height"
               :srcset="renderSrcSet"
               :src="renderSrc"
               :alt="image.alt">
        </picture>
      </div>
      <div class="person-card__content">
        <h4 v-if="personName"
            class="person-card__heading">
          {{ personName }}
        </h4>
        <p v-if="jobTitle"
           class="person-card__job-title">
          {{ jobTitle }}
        </p>
        <gl-link class="person-card__link"
                 :as-dummy="true">
          {{ mergedLinkText }}
        </gl-link>
      </div>
    </a>
  </div>
</template>

<script>
import GlLink from "../Base/GlLink.vue";

export default {
  name: "PersonCard",
  components: { GlLink },
  props: {
    url: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default: null,
    },
    personName: {
      type: String,
      default: null,
    },
    jobTitle: {
      type: String,
      default: null,
    },
    linkText: {
      type: String,
      default: "More about {0}",
    },
    thinPadding: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    renderSrc () {
      let result = null;

      if ( this.image && this.image.url ) {
        result = `${this.image.url}?height=230&width=400&mode=min&format=*`;
      }

      return result;
    },
    renderSrcSet () {
      let result = null;

      if ( this.image && this.image.url ) {
        result = `${this.image.url}?height=230&width=400&mode=min&format=* 1x, ${this.image.url}?height=460&width=800&mode=min&format=* 2x`;
      }

      return result;
    },
    mergedLinkText () {
      let result = null;

      if ( this.linkText && this.personName ) {
        result = this.linkText.replace( "{0}", this.personName );
      } else {
        result = "More about person";
      }

      return result;
    },
  },
};
</script>
